import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => ({
  subtitle: {
    padding: theme.spacing(1, 0),
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(2),
    color: theme.palette.text.main,
    backgroundImage: "linear-gradient(120deg, #F4B793 0%, #F4B793 100%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 0.2em",
    backgroundPosition: "0 88%",
    transition: "background-size 0.25s ease-in"
  }
}));
